/**
 * The IDC Notetaker module flag (AIC-1437, plan D8 and section 9): off unless the build sets VITE_NOTETAKER_ENABLED=true.
 * Read only here, and at call time, so a test can set it. Off, the portal has no Notetaker route, link or chunk load.
 */
export const notetakerEnabled = (): boolean => import.meta.env.VITE_NOTETAKER_ENABLED === "true";

/**
 * Who sees Notetaker once the flag is on (D15): "admins" (the default, Phase 1) shows it only to Notetaker.Admin;
 * "role" (the pilot, AIC-1946) to holders of Notetaker.User or Notetaker.Admin; "everyone" to every signed-in user. Admin
 * is for Notetaker.Admin only in all three. Anything else is "admins". What a person may read is enforced by notetaker-api, not here.
 */
export const notetakerAudience = (): "admins" | "role" | "everyone" => {
  const audience = import.meta.env.VITE_NOTETAKER_AUDIENCE;
  return audience === "everyone" || audience === "role" ? audience : "admins";
};
